import * as actionType from '../onBoard/ActionType';

const initialState = {
  registerForm: {
    firstName: 'Tim',
    lastName: 'Lee',
    email: 'tim.lee@bookipay.com',
    emailVerified: false,
    phoneVerified: false
  }
};

export function UserReducer(state = initialState, action) {
  switch (action.type) {
    case actionType.SET_REGISTER_FORM:
      return {
        ...state,
        registerForm: {
          ...state.registerForm,
          ...action.payload
        }
      };
    default:
      return state;
  }
}

export * from './getAccessToken';
export * from './whoami';
export * from './forgotPassword';
export * from './signup';
export * from './changePassword';
export * from './updateUser';
export * from './getStripeOnboardLink';
